import { ReflectUtils } from "@dooboostore/core";
const RouterMetadataKey = Symbol.for("simple-boot:router-metadata");
const routerProcess = (config, target) => {
  getRoutes(target)?.forEach((it) => {
    config.route = config.route ?? {};
    const paths = Array.isArray(it.config.path) ? it.config.path : [it.config.path];
    for (const path of paths) {
      if (config.route[path]) {
        const route2 = config.route[path];
        route2.propertyKeys.push(it.propertyKey);
        route2.filters = route2.filters ?? [];
        if (Array.isArray(it.config.filters)) {
          route2.filters.push(...it.config.filters);
        } else if (it.config.filters) {
          route2.filters.push(it.config.filters);
        }
      } else {
        config.route[path] = { target, propertyKeys: [it.propertyKey], filters: it.config.filters };
      }
    }
  });
  ReflectUtils.defineMetadata(RouterMetadataKey, config, target);
};
function Router(configOrTarget) {
  if (typeof configOrTarget === "function") {
    const routerConfig = {
      path: ""
    };
    routerProcess(routerConfig, configOrTarget);
  } else {
    return (target) => {
      configOrTarget.path = configOrTarget.path ?? "";
      routerProcess(configOrTarget, target);
    };
  }
}
const getRouter = (target) => {
  if (target != null && typeof target === "object") {
    target = target.constructor;
  }
  try {
    return ReflectUtils.getMetadata(RouterMetadataKey, target);
  } catch (e) {
  }
};
const RouteMetadataKey = Symbol.for("simple-boot:route-metadata");
const Route = (config) => {
  return (target, propertyKey, descriptor) => {
    const saveRouteConfigs = ReflectUtils.getMetadata(RouteMetadataKey, target.constructor) ?? [];
    const method = target[propertyKey];
    saveRouteConfigs.push({ propertyKey, method, config });
    ReflectUtils.defineMetadata(RouteMetadataKey, saveRouteConfigs, target.constructor);
    ReflectUtils.defineMetadata(RouteMetadataKey, config, target, propertyKey);
  };
};
const getRoute = (target, propertyKey) => {
  return ReflectUtils.getMetadata(RouteMetadataKey, target, propertyKey);
};
const getRoutes = (target) => {
  if (target !== null && void 0 !== target && typeof target === "object") {
    target = target.constructor;
  }
  return ReflectUtils.getMetadata(RouteMetadataKey, target);
};
const router = Router;
const route = Route;
export {
  Route,
  RouteMetadataKey,
  Router,
  RouterMetadataKey,
  getRoute,
  getRouter,
  getRoutes,
  route,
  router,
  routerProcess
};
//# sourceMappingURL=Router.js.map
